import { useMemo } from 'react';
import { useJiraSoftwareProjectNavigation } from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/common/project-sidebar-navigation-resource/index.tsx';
import type { UseFlexibleNomenclatureReturns } from './types.tsx';

export const useFlexibleNomenclature = (): UseFlexibleNomenclatureReturns => {
	// V4 API, useJiraSoftwareProjectNavigation is cached.
	const { data, loading, error } = useJiraSoftwareProjectNavigation();
	const extractedData = useMemo(() => data && data.flexibleNomenclatureData, [data]);
	return {
		data: {
			levelOneName: extractedData?.levelOneName,
		},
		loading,
		error,
	};
};
